import React, { Component, Fragment } from 'react';
import TextInput from './textInput.js';
import SelectInput from './selectInput.js'
import SubmitButton from './submitButton.js';
import RadioInput from './radioInput.js';
import PropTypes from 'prop-types';

import { validateForm, removeMoneySymbols } from '../utils.js';

import {
  YOUR_ELIGIBLE_PAY,
  PRIMARY_RETIREMENT_BENEFITS,
  POSITION_TYPE,
  MEDICAL_PLAN, MEDICAL_PLAN_COVER,
  DENTAL_PLAN, DENTAL_PLAN_COVER,
  HIRE_DATE_TIER,
  REHIRED_OR_INELIGIBLE,
  HIRE_BEFORE_DATE
} from '../constants/fragments.js';

import {
  options_pensionChoice,
  options_pensionChoiceElig,
  options_medicalPlan,
  options_medicalCov,
  options_dentalPlan,
  options_denCov,
  options_hired_date_tier,
  buttons_rehired,
  buttons_hired_before_date,

  OPT_OUT_OF_MEDICAL,
  OPT_OUT_OF_DENTAL,
  ON_OR_AFTER_JULY_1_2016,
  PENSION_CHOICE,
  YES,
  NO
} from '../constants/menuOptions.js'

import {
    FORM_ERROR,
  } from '../constants/errorDisplay.js';

class CalculatorFrom extends Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this);
    this.focusRef = React.createRef();
    this.state = {
      med_plan: '',
      med_cov: '',
      dental_plan:'',
      dental_cov:'',
      hired_date_tier:'',
      pension_choice:'',
      pension_choice_elig: '',
      lblRehired: NO,
      hiredBeforeDate: NO,
      salary:'',
      disabled_den_Plan: false,
      disabled_med_Plan:false
    }
  }

  handleChange(e) {

    const { name, value } = e.target;
    const newState = { [name]: value }

    switch (name) {
      case 'med_plan':
        if (value === OPT_OUT_OF_MEDICAL) {
          newState.med_cov = '';
          newState.disabled_med_Plan = true;
        } else {
          newState.disabled_med_Plan = false;
        }
        break;

      case 'dental_plan':
        if (value === OPT_OUT_OF_DENTAL) {
          newState.dental_cov = '';
          newState.disabled_den_Plan = true;
        }
        else{
          newState.disabled_den_Plan = false;
        }
      break;

      case 'hired_date_tier':
        if (value !== ON_OR_AFTER_JULY_1_2016) {
          newState.pension_choice = '';
          newState.pension_choice_elig = '';
          newState.lblRehired = NO;
          newState.hiredBeforeDate = NO;
        }
        break;

      case 'lblRehired':
        if (value === NO) {
          newState.hiredBeforeDate = NO;
        }
        break;

      case 'hiredBeforeDate':
        if (value === YES) {
          newState.pension_choice_elig = '';
        }
        break;

      case 'pension_choice':
        if (value !== PENSION_CHOICE) {
          newState.pension_choice_elig = '';
        }
        break;

      default:
        //nothing
    }

    this.setState(
      newState
    );
  }

  handleValidation = () => {
    const errors = validateForm(this.state);
    this.props.setErrors(FORM_ERROR, errors);

    if (errors.length) {
      return false;
    }

    return true;
  };

  handleSubmit = e => {
    e.preventDefault();
    const passedValidation = this.handleValidation();

    const salary = this.state.salary.trim();

    if (passedValidation) {
      const formData = {
        ...this.state,
        salary: parseFloat(removeMoneySymbols(salary))
      };

      this.props.onSubmit(formData);
    }
  };

  render() {

    const {
      med_cov,
      med_plan,
      dental_plan,
      dental_cov,
      hired_date_tier,
      lblRehired,
      hiredBeforeDate,
      pension_choice,
      pension_choice_elig,
      disabled_med_Plan,
      disabled_den_Plan,
      salary,
    } = this.state;

    const { shouldLockForm } = this.props;

    return (
      <form id='form_error' onSubmit={this.handleSubmit} >

        <SelectInput
          selectOptions={options_medicalPlan}
          name='med_plan'
          id='medPlan'
          label={MEDICAL_PLAN}
          value={med_plan}
          onChange={this.handleChange}
          className='styled-select-1'
          wrapperClass= 'tcc-set'
          disabled={shouldLockForm}
        />

        <SelectInput
          disabled={disabled_med_Plan || shouldLockForm}
          selectOptions={options_medicalCov}
          name='med_cov'
          id='med_cov'
          label={MEDICAL_PLAN_COVER}
          value={med_cov}
          onChange={this.handleChange}
          className='styled-select-1'
          wrapperClass= 'tcc-set'
        />

        <SelectInput
          selectOptions={options_dentalPlan}
          name='dental_plan'
          id='dental_plan'
          label={DENTAL_PLAN}
          value={dental_plan}
          onChange={this.handleChange}
          className='styled-select-1'
          wrapperClass= 'tcc-set'
          disabled={shouldLockForm}
        />

        <SelectInput
          disabled={disabled_den_Plan || shouldLockForm}
          selectOptions={options_denCov}
          name='dental_cov'
          id='dental_cov'
          label={DENTAL_PLAN_COVER}
          value={dental_cov}
          onChange={this.handleChange}
          className='styled-select-1'
          wrapperClass= 'tcc-set'
        />

        <SelectInput
          selectOptions={options_hired_date_tier}
          name='hired_date_tier'
          id='hired_date_tier'
          label={HIRE_DATE_TIER}
          value={hired_date_tier}
          onChange={this.handleChange}
          className='styled-select-1'
          wrapperClass= 'tcc-set'
          disabled={shouldLockForm}
        />

      {
        (hired_date_tier === ON_OR_AFTER_JULY_1_2016) &&
          <Fragment>

            <RadioInput
              buttons={buttons_rehired}
              onChange={this.handleChange}
              label={REHIRED_OR_INELIGIBLE}
              value={lblRehired}
              id='lblRehired'
              name='lblRehired'
              wrapperClass= 'tcc-set tcc-big-label'
              className ='tcc-radios'
              disabled={shouldLockForm}
            />

          {
            (lblRehired === YES) &&
              <RadioInput
                buttons={buttons_hired_before_date}
                onChange={this.handleChange}
                label={HIRE_BEFORE_DATE}
                value={hiredBeforeDate}
                id='hiredBeforeDate'
                name='hiredBeforeDate'
                wrapperClass= 'tcc-set'
                className ='tcc-radios'
                disabled={shouldLockForm}
              />
          }

            <SelectInput
              selectOptions={options_pensionChoice}
              name='pension_choice'
              id='pension_choice'
              label={PRIMARY_RETIREMENT_BENEFITS}
              value={pension_choice}
              onChange={this.handleChange}
              className="styled-select-1"
              wrapperClass= "tcc-set"
              disabled={shouldLockForm}
            />

          {
            (pension_choice === PENSION_CHOICE) && (hiredBeforeDate !== YES) &&
              <SelectInput
                selectOptions={options_pensionChoiceElig}
                name='pension_choice_elig'
                id='pension_choice_elig'
                label={POSITION_TYPE}
                value={pension_choice_elig}
                onChange={this.handleChange}
                className="styled-select-1"
                wrapperClass= "tcc-set"
                disabled={shouldLockForm}
              />
          }

          </Fragment>

      }

      <TextInput
        //className='reqast'
        name='salary'
        id='tip_sal'
        label={YOUR_ELIGIBLE_PAY}
        value={salary}
        onChange={this.handleChange}
        className= 'tcc-set'
        inputClass= 'tcc-txt'
        size ='40'
        disabled={shouldLockForm}
      />

    <SubmitButton
      wrapperClass= "tcc-set"
      className='btn-dark-blue'
      value= 'Estimate'
      name= 'submit'
      id='submit'
      disabled={shouldLockForm}
    />
  </form>
    );
  }
}

CalculatorFrom.propTypes = {
  id: PropTypes.string,
  onSubmit: PropTypes.func,
  shouldLockForm: PropTypes.bool
};

export default CalculatorFrom;
